
import 'aos/dist/aos.css'
import { defineComponent, PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
export interface Photo {
  id: number;
  image?: string;
  title: string;
  images?: string[];
}
export default defineComponent({
  props: {
    photos: Array as PropType<Photo[]>
  },
  setup (props) {
    const router = useRouter()
    const goProduct = (id: string) => {
      router.push(`/shop/default/${id}`)
    }
    const photoRow1 = computed(() => {
      if (!props.photos) return
      return props.photos.slice(0, props.photos.length / 3)
    })
    const photoRow2 = computed(() => {
      if (!props.photos) return
      return props.photos.slice(3, 2 * props.photos.length / 3)
    })
    const photoRow3 = computed(() => {
      if (!props.photos) return
      return props.photos.slice(6, props.photos.length)
    })
    return {
      photoRow1,
      photoRow2,
      photoRow3,
      goProduct
    }
  }
})
